export default "__VITE_ASSET__BvR5YFl3__"